<template>
    <div class="main-container">
        <router-view></router-view>
		<!-- Navbar section -->
		<HeaderSoftware />

        <!-- hero section -->
        <HeroClinic />

        <!-- about section -->
        <div class="box-image-area section-space--ptb_120" id="about">
            <div class="container">
                <div class="section-title-wrapper text-center section-space--mb_60 wow move-up">
                    <h2 class="section-title mb-15">{{$t('isletmenizibuyutun')}}</h2>
                    <span class="section-text">{{$t('trendlereonculuketmekicinplanyapin')}}</span>
                </div>
                <!-- about component -->
                <AboutExpand />
            </div>
        </div>

        <!-- business analytics start -->
        <div class="feature-icon-list-area section-space--pb_120">
            <div class="container">
                <div class="section-title-wrapper text-center section-space--mb_100">
                    <h2 class="section-title mb-30">{{$t('gercekzamanliisanalizleri')}}</h2>
                    <div class="video-button-container video-popup">
                        <silentbox-single src="https://www.youtube.com/watch?v=9No-FiEInLA">
                            <div class="video-play">
                                <i class="fa fa-play-circle"></i>
                                <span class="video-text">INTRO & DEMO VIDEO</span>
                            </div>
                        </silentbox-single>
                    </div>
                </div>
            </div>
            <!-- feature list component -->
            <FeatureList />
        </div>

        <!-- feature carousel -->
        <!-- <FeatureTwo /> -->

        <!-- accordion section start -->
        <div class="accordion-wrapper section-space--pb_90">
            <div class="container">
                <div class="row ">
                    <div class="col-lg-12">
                        <div class="faq-wrapper section-space--pt_90">
                            <div class="section-elements-title mb-30">
                                <h4>{{$t('destekaraclari')}}</h4>
                            </div>
                            <!-- Toggle component -->
                            <AccordionToggle />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- accordion section end -->

        <!-- brand logo carousel -->
		<BrandLogoCarousel />

        <CtaThree />

         <!-- footer section -->
        <FooterMain />

        <!-- offcanvas search component -->
         <OffcanvasSearchBox /> 

        <!-- off-canvas mobile menu -->
        <OffCanvasMobileMenu />
    </div>
</template>
<script>
import HeaderSoftware from "../components/HeaderSoftware";
import HeroClinic from '@/components/sections/HeroClinic'
import AboutExpand from '../components/AboutExpand'
import FeatureList from "../components/FeatureList";
import AccordionToggle from '@/components/AccordionToggle'
import FooterMain from '@/components/FooterMain'
import BrandLogoCarousel from "../components/BrandLogoCarousel";
import CtaThree from '@/components/CtaThree'
import OffcanvasSearchBox from '@/components/OffcanvasSearchBox'
import OffCanvasMobileMenu from '@/components/OffCanvasMobileMenu'

export default {
     
     components: {
     HeaderSoftware,
     HeroClinic,
     AccordionToggle,
     AboutExpand,
     FeatureList,
     FooterMain,
     BrandLogoCarousel,
     CtaThree,
     OffcanvasSearchBox,
     OffCanvasMobileMenu
     }
}
</script>
